/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/prefer-default-export
export const transformRegisterUserData = obj => {
    obj.name = obj.name.toUpperCase();
    obj.email = obj.email.toUpperCase();

    return obj;
};